import axios from "axios";
import CryptoJS from "crypto-js";

const merchant = {
  userID: "merchantb",
  key: "6653528fc2f820aa770bc994eb9b56561b319ff7d6cbd2a3abba7e99cb2d1af8",
}

let Request = axios.create();

//====api=======
export const Api = (data) => {
  data.userID = merchant.userID;
  data.sign = genSign(data);

  return Request.post("/merapi/order", data);
}

function genSign(data) {
  let signString = "amount=" + data.amount + "&orderId=" + data.orderId + "&key=" + merchant.key;

  return CryptoJS.MD5(signString).toString();
}
